/* ================================================================================
   PortalBackground — the site-wide ambient background.
   Extracted from the login (AuthLayout) look: a soft blue→white→cyan diagonal
   gradient with gently drifting, heavily-blurred colour orbs. This is the
   "colour + pattern" identity applied across the whole public portal.

   Performance / a11y notes:
   - `position: fixed` so the gradient + orbs stay in the viewport while the page
     scrolls (one canvas, never re-laid-out) and translucent sections reveal it.
   - Orbs animate via GPU `transform` only (no layout/paint), and only 3 orbs —
     cheap on low-end Android / slow 4G. `prefers-reduced-motion` (global rule in
     index.css) collapses the animation duration, so motion-sensitive users see a
     calm static gradient.
   - Decorative only: `aria-hidden`, `pointer-events-none`, and painted at -z-10 so
     all real content/headers/footers sit above it.
   ================================================================================ */

export function PortalBackground() {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 -z-10 overflow-hidden pointer-events-none bg-gradient-to-br from-blue-100 via-white to-cyan-100"
    >
      {/* Blue/cyan orb — top left */}
      <div
        className="absolute -top-24 -left-24 w-[520px] h-[520px] rounded-full bg-gradient-to-br from-blue-400/40 to-cyan-400/30 blur-3xl"
        style={{ animation: 'orbDrift1 16s ease-in-out infinite' }}
      />
      {/* Emerald/teal orb — bottom right */}
      <div
        className="absolute -bottom-24 -right-24 w-[440px] h-[440px] rounded-full bg-gradient-to-br from-emerald-400/35 to-teal-400/25 blur-3xl"
        style={{ animation: 'orbDrift2 14s ease-in-out infinite' }}
      />
      {/* Cyan/blue orb — mid centre */}
      <div
        className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[340px] h-[340px] rounded-full bg-gradient-to-br from-cyan-300/30 to-blue-300/20 blur-3xl"
        style={{ animation: 'orbDrift3 18s ease-in-out infinite' }}
      />
    </div>
  )
}

export default PortalBackground